import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import hi from '../locales/hi.json';
import id from '../locales/id.json';
import ja from '../locales/ja.json';
import ne from '../locales/ne.json';
import ptBr from '../locales/pt-BR.json';
import vi from '../locales/vi.json';
import zhPinyin from '../locales/zh-pinyin.json';

const resources = {
  en: { translation: en },
  ne: { translation: ne },
  id: { translation: id },
  'pt-BR': { translation: ptBr },
  vi: { translation: vi },
  'zh-pinyin': { translation: zhPinyin },
  hi: { translation: hi },
  ja: { translation: ja },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('selectedLanguage') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
